var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEconomyPointsEarned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4641 0.948341C21.3205 -0.316114 18.6795 -0.316113 16.5359 0.948342L3.4641 8.65908C1.32051 9.92354 0 12.2603 0 14.7893V30.2107C0 32.7397 1.32051 35.0765 3.4641 36.3409L16.5359 44.0517C18.6795 45.3161 21.3205 45.3161 23.4641 44.0517L36.5359 36.3409C38.6795 35.0765 40 32.7397 40 30.2107V14.7893C40 12.2603 38.6795 9.92354 36.5359 8.65908L33.1899 6.68538L22.6974 17.9867L31.8241 18.7127L13.3305 38.0727L20.0554 22.3427H12.6099L24.0788 1.31093L23.4641 0.948341Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomyPointsEarned);
export default __webpack_public_path__ + "static/media/economyPointsEarned.d7063d826cb91ad6672c7f3320c7db95.svg";
export { ForwardRef as ReactComponent };